import * as React from 'react';
import { observer } from 'mobx-react-lite';
import MeetingMessage from 'owa-service/lib/contract/MeetingMessage';
import MeetingMessageActionEntrySource from '../../store/schema/MeetingMessageActionEntrySource';
import isMeetingCancellation from '../../utils/isMeetingCancellation';
import isMeetingRequest from '../../utils/isMeetingRequest';
import isMeetingResponse from '../../utils/isMeetingResponse';
import MeetingRequestSummary from './MeetingRequestSummary';
import MeetingResponseSummary from './MeetingResponseSummary';
import MeetingCancellationSummary from './MeetingCancellationSummary';

const styles = require('./MeetingMessageSummary.scss');

export interface MeetingMessageSummaryProps {
    item: MeetingMessage;
    entrySource: MeetingMessageActionEntrySource;
}

const MeetingMessageSummary = observer(function MeetingMessageSummary(
    props: MeetingMessageSummaryProps
) {
    const { item, entrySource } = props;

    const itemClass = item.ItemClass;

    let component = null;

    if (isMeetingRequest(itemClass)) {
        component = <MeetingRequestSummary item={item} />;
    } else if (isMeetingResponse(itemClass)) {
        component = <MeetingResponseSummary item={item} entrySource={entrySource} />;
    } else if (isMeetingCancellation(itemClass)) {
        component = <MeetingCancellationSummary item={item} />;
    }

    return component && <div className={styles.container}>{component}</div>;
});
export default MeetingMessageSummary;
